import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@material-ui/core';
import BuzzLabel from '../BuzzLabel/BuzzLabel';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BuzzMultiSelect({
  id,
  label,
  value = [],
  options = [],
  onChange,
  valueKey = 'value',
  labelKey = 'label',
  required = false,
}) {
  if (!Array.isArray(options)) throw new Error('options must be an array');

  return (
    <div>
      {/* <InputLabel>{label}</InputLabel> */}
      <BuzzLabel label={label} required={required} id={id} />
      <FormControl fullWidth>
        <Select
          style={{ height: '50px' }}
          multiple
          value={value}
          onChange={onChange}
          input={<OutlinedInput />}
          MenuProps={MenuProps}>
          {options.map((option, index) => (
            <MenuItem key={index} value={option[valueKey]}>
              {option[labelKey]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
